import { Controller } from "@hotwired/stimulus"

// Toggles the off-canvas mobile sidebar drawer via a body class — the CSS
// only turns the sidebar into an overlay drawer under the mobile
// breakpoint, so this is inert (and harmless) on desktop widths.
export default class extends Controller {
  toggle() {
    document.body.classList.toggle("sidebar-open")
  }

  close() {
    document.body.classList.remove("sidebar-open")
  }
}
